import axios from "axios";

export const state = {
    groupaccountinvoices: [],
};

export const getters = {
    groupaccountinvoices: state => state.groupaccountinvoices,
};

export const mutations = {
    setGroupAccountInvoices(groupaccountinvoices, newValue) { state.groupaccountinvoices = newValue},
};

export const actions = {
    fetchGroupAccountInvoices({ commit }) {
        axios.get('/groupaccountinvoices').then(res => {
            commit('setGroupAccountInvoices', res.data.invoices)
        })
    },
    filterGroupAccountInvoices({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtergroupaccountinvoices";
        axios.post(url, formData).then((response) => {
            commit('setGroupAccountInvoices', response.data.invoices)
        })
    },
};
